import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy, ViewChild } from '@angular/core';
import { NavigationService } from '../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../models/table-column-header';
import { Subscription} from 'rxjs';
import { ApiService } from '../../providers/api.service';
import { SM_CONSTANTS } from '../../shared/constants/sm-constants';
import { MatDialog } from '@angular/material/dialog';
import { AddNewBookingComponent } from 'src/app/shared/components/add-new-booking/add-new-booking.component';
import { ManageBookingComponent } from 'src/app/shared/components/manage-booking/manage-booking.component';
import { AssignJobComponent } from 'src/app/shared/components/assign-job/assign-job.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { CustomiseBookingComponent } from 'src/app/shared/components/customise-booking/customise-booking.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { MatSnackBar,MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
  selector: 'sm-purchased-plans',
  templateUrl: './purchased-plans.component.html',
  styleUrls: ['./purchased-plans.component.scss']
})
export class PurchasedPlansComponent implements OnInit, OnDestroy {
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
 bookingType: string = ''
  pageTitle: string = 'Bookings' ;
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  selectedValue: string = '0'
  headerCustomTemplate!: TemplateRef<any>;
  @ViewChild('costTemplate', { static: true })
  costTemplateRef!: TemplateRef<HTMLElement>;
  toDate:any = new Date().toISOString().replace(/T.*/,'').split('-').join('-');
  fromDate:any = ''
  bookingsData: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "Pack name",
      columnProperty: "planName"
    },
    {
      columnName: "description",
      columnProperty: "planDescription"
    },
    {
      columnName: "no of users",
      columnProperty: "noOfUsers"
    },
    {
      columnName: "no of users used",
      columnProperty: "noOfUsersActivate"
    },
    {
      columnName: "no of entity",
      columnProperty: "noOfEntity"
    },
    {
      columnName: "no of entities used",
      columnProperty: "noOfEntityActivate"
    },
    {
      columnName: "validity (in days)",
      columnProperty: "validity",
    },
    {
      columnName: "purchased on",
      columnProperty: "creationDate"
    },
    
    
    
  ];
  tableDisplayColumns2: ITableColumnHeader[] = [
    {
      columnName: "Pack name",
      columnProperty: "planName"
    },
    {
      columnName: "description",
      columnProperty: "description"
    },
    {
      columnName: "no of users",
      columnProperty: "noOfUsers"
    },
    {
      columnName: "no of entity",
      columnProperty: "noOfEntity"
    },
    {
      columnName: "Plan cost",
      columnProperty: "unitCost",
    },
    {
      columnName: "Total cost",
      columnProperty: "totalCost",
    },
    {
      columnName: "validity (in days)",
      columnProperty: "validity",
    },
    {
      columnName: "purchased on",
      columnProperty: "creationDate"
    },
    {
      columnName: "Transaction Id",
      columnProperty: "paymentRef"
    },
    
    
    
  ];
  private _apiSubscription: Subscription;
  subsData: any = []
  transactionData: any = []
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, public _modelRef: MatDialog,  private loaderService: LoaderServiceService, private messagingService: MessagingService, private angularFireMessaging: AngularFireMessaging, private _snackBar: MatSnackBar) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      console.log("inBookings1:", resData)
    

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_SUBSCRIPTION_HISTORY_BY_ID){
        this.subsData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.subsData.push(element)
          });
        }
        this.loaderService.showLoader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_TRANSACTIONS_LIST){
        this.transactionData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.transactionData.push(element)
          });
        }
        this.loaderService.showLoader = false
      }
     

     
      
        
      this.loader = false;
      this.visible = true
    });
   }

  ngOnInit(): void {
    
    // this.loader = true  
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
      this.bookingType = data.bookingType

      
    }) 
    this.loader = true
    this.loaderService.showLoader = true;
    this._apiService.getSubcriptionHistoryById(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), '0',this.countryInfo.countryCode)
  


  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  openSnackBar(message: string, action?: string) {
    let config = new MatSnackBarConfig();
    config.panelClass = ['custom-class'];
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.duration = 3000
    this._snackBar.open(message, action , config );
  }

  refreshScreen(){
    this.loaderService.showLoader = true;
    this._apiService.getEntitySlotsInfo(this.entityHashId, this.bookingType, this.selectedValue)
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
  search(){
    console.log(this.fromDate);
    console.log(this.toDate);
    this._apiService.getBookingsList(this.entityHashId, this.fromDate, this.toDate)
    this.visible= false
    // this.loader = true
  }
  countryInfo:any = typeof sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT) == 'string' ? JSON.parse(sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)!) : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
  
  changeChip(value:string){
    this.selectedValue = value
    // this.loader = true
    this.loaderService.showLoader = true;
    if(value == '0'){
      this._apiService.getSubcriptionHistoryById(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), '0',this.countryInfo.countryCode)
    }
    else if(value == '1'){
      this._apiService.getSubcriptionHistoryById(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), '1',this.countryInfo.countryCode)
    }
    else if(value == '2'){
      this._apiService.getTransactionsList()
    }
    
  }

 

  createNewBooking() {
    let data = {
      entityHash: this.entityHashId,
      serviceType: this.bookingType
    }
    this._modelRef.open(AddNewBookingComponent, {
      width: '700px',
      data: {
        title: 'New Booking',
        ref: this._modelRef,
        data: data
      },
    });
  }

  startProcess(item:any){
    
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        appointmentHash: item.hash_id,
        bookingStatus: 3,
        startTime: this.formatTime(new Date()),
        endTime: item.bookingEndTime.slice(0,5),
        entityHash: item.entityHash,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id
      }
    }

    console.log(data);
    this.loaderService.showLoader = true
    this._apiService.updateBookingStatus(data)
    
  }
  confirmBooking(item:any){
    
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        appointmentHash: item.hash_id,
        bookingStatus: 5,
        startTime: item.bookingStartTime.slice(0,5),
        endTime: item.bookingEndTime.slice(0,5),
        entityHash: item.entityHash,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id
      }
    }

    console.log(data);
    this.loaderService.showLoader = true
    this._apiService.updateBookingStatus(data)
    
  }
  cancelBooking(item:any){
    // if(confirm("Are you sure you want to cancel this booking?")){

    
    // let data = {
    //   bookingStatusInfo: {
    //     appointmentHash: item.hash_id,
    //     bookingStatus: 8,
    //   }
    // }

    // console.log(data);
    // this.loaderService.showLoader = true
    // this._apiService.updateBookingStatus(data)
    // }

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to cancel this booking?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let data = {
          bookingStatusInfo: {
            bookingStatus: 8,
            assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
            assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
            appointmentHash: item.hash_id,
            startTime: item.bookingStartTime.slice(0,5),
            endTime: item.bookingEndTime.slice(0,5),
            entityHash: item.entityHash,
            customerPh: item.customer_phone,
            customerName: item.customer_name,
            price: item.price,
            bookingDate: item.bookingDate,
            note: item.note,
            bookingType: item.bookingType,
            customerHash: item.customerInfo.hash_id
          }
        }
    
        console.log(data);
        this.loaderService.showLoader = true
        this._apiService.updateBookingStatus(data)
      }
    })
    
  }

  done(item:any) {
    let data = {
      entityHash: this.entityHashId,
      serviceType: this.bookingType,
      bookingData: item
    }
    this._modelRef.open(ManageBookingComponent, {
      width: '700px',
      data: {
        title: 'Manage Booking',
        ref: this._modelRef,
        data: data
      },
    });
  }

  assignJob(item:any){
    
    this._modelRef.open(AssignJobComponent, {
      width: '800px',
      data: {
        title: 'Assign job',
        ref: this._modelRef,
        data: item
      },
    });
  }

  reset(item:any){

    // if(confirm("This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?")){
    //   let data =  {
    //     appointmentHashId: item.hash_id
    //   }
    //   this.loaderService.showLoader = true
    //   this._apiService.resetBookingDetails(data)
    // }

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      maxWidth: '700px',
      data : {
        title : 'Alert',
        message : 'This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let data =  {
          appointmentHashId: item.hash_id
        }
        this.loaderService.showLoader = true
        this._apiService.resetBookingDetails(data)
      }
    })
    
  }

  openInvoice(item:any){
    this._modelRef.open(InvoiceComponent, {
      width: '510px',
      data: {
        title: 'Invoice',
        ref: this._modelRef,
        data: item.hash_id
      },
    });
  }
  bookingDetails(item:any){
    this._modelRef.open(BookingDetailsComponent, {
      width: '700px',
      data: {
        title: 'Bookings Details',
        ref: this._modelRef,
        data: item
      },
    });
  }

  customiseBooking(item:any){
    let data = {
      entityHash: this.entityHashId,
      serviceType: this.bookingType,
      bookingData: item
    }
    this._modelRef.open(CustomiseBookingComponent, {
      width: '700px',
      data: {
        title: 'Edit Booking Operation',
        ref: this._modelRef,
        data: data
      },
    });
  }

  sortObjectsDescendingByBookingNumber(array: any) {
    return array.slice().sort((a:any, b:any) => parseInt(b.appointment_no) - parseInt(a.appointment_no));
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0'); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Same for minutes
    return `${hours}:${minutes}`;
}

createNotification(title:any, text:any) {
  const noti = new Notification(title, {
    body: text,
  });
}


}



